






































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import DocumentForm from "@/components/DocumentForm.vue";

console.log(moment());

@Component({ components: { DocumentForm } })
export default class Documents extends Vue {
  items: any[] = [];
  query: any = {
    from: null,
    until: null,
    publishing_status_id: null,
  };
  currentPage = 1;
  defaultSortDir = "desc";
  currentDocument = null;
  modal = false;
  form: any = {
    publishing_status_id: null,
    postponed_id: null,
    publishing_status_reason: null,
    actual_publishing_date: null,
  };
  publishStatus: any[] = [];
  publishingPostponed: any[] = [];

  monthNames = [
    "Siječanj",
    "Veljača",
    "Ožujak",
    "Travanj",
    "Svibanj",
    "Lipanj",
    "Srpanj",
    "Kolovoz",
    "Rujan",
    "Listopad",
    "Studeni",
    "Prosinac",
  ];

  dayNames = ["N", "P", "U", "S", "Č", "P", "S"];

  minDate() {
    return moment().startOf("day").toDate();
  }

  async mounted() {
    this.load();

    //  TODO proper url and history, without '#'
    // console.log(
    //   this.$route.query.publishing_status_id,
    //   "this.$route.query.publishing_status_id"
    // );
    // if (this.$route.query.publishing_status_id)
    //   this.query.publishing_status_id = this.$route.query.publishing_status_id;

    this.publishStatus = (
      await axios.get<any[]>("/lookup/publish-status", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.publishingPostponed = (
      await axios.get<any[]>("/lookup/publishing-postponed", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
  }

  availablePublishStatus() {
    return this.publishStatus.filter((it) => it.id === 1 || it.id > 4);
  }

  @Watch("$route")
  onRouteChange() {
    this.load();
  }

  @Watch("query", { deep: true })
  onQueryChange() {
    this.search();
  }

  async load() {
    if (this.$route.query.from)
      this.query.from = new Date(this.$route.query.from.toString());
    else this.query.from = null;
    if (this.$route.query.until)
      this.query.until = new Date(this.$route.query.until.toString());
    else this.query.until = null;
    // var params = Object.assign({ forPublishing: true }, this.$route.query);
    var params = Object.assign({}, this.$route.query);
    let items = (
      await axios.get<any[]>("/document", {
        params: params,
        headers: { Authorization: "Bearer " + localStorage.token },
      })
    ).data;

    this.items = items.map((el) => {
      el.actual_publishing_date = el.actual_publishing_date
        ? moment(el.actual_publishing_date)
        : "";
      el.planned_publishing_date = moment(el.planned_publishing_date);
      return el;
    });
  }

  search() {
    var query = Object.assign({}, this.query);

    if (this.query.from)
      query.from = moment(this.query.from).format("YYYY-MM-DD");
    if (this.query.until)
      query.until = moment(this.query.until).format("YYYY-MM-DD");

    this.$router.push({ query: query });
  }

  resetSearch() {
    this.query = {};
  }

  edit(row: any) {
    this.modal = true;
    this.form.current_status_id = row.publishing_status_id;
    this.form.publishing_status_id = row.publishing_status_id;
    this.form.publishing_status_reason = row.publishing_status_reason;
    this.form.actual_publishing_date = row.actual_publishing_date
      ? new Date(row.actual_publishing_date)
      : new Date();
    this.form.postponed_id = row.postponed_id;
    this.form.id = row.document_id;
  }

  getPublishStatus(id: number) {
    var found = this.publishStatus.find((it) => it.id === id);
    return found ? found.name : "";
  }

  getPostponed(id: number) {
    var found = this.publishingPostponed.find((it) => it.id === id);
    return found ? found.name : "";
  }

  async submitForm() {
    await axios.post<[]>(
      `/document/${this.form.id}/publishing-status`,
      this.form,
      {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      }
    );
    this.modal = false;
    this.load();
  }
}
